(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    let lockedScrollY = 0;

    const getDetails = (fromEl) => fromEl && fromEl.closest('details.menu-drawer-container');

    const closeDrawer = (details) => {
      if (!details || !details.open) return;
      const summary = details.querySelector('summary');
      if (summary) summary.click();
    };

    const lockScroll = () => {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('hb-menu-scroll-lock');
      document.body.style.top = `-${lockedScrollY}px`;
    };

    const unlockScroll = () => {
      if (!document.body.classList.contains('hb-menu-scroll-lock')) return;
      document.body.classList.remove('hb-menu-scroll-lock');
      document.body.style.top = '';
      window.scrollTo(0, lockedScrollY);
    };

    document.addEventListener('click', (event) => {
      const closeBtn = event.target.closest('[data-hb-drawer-close]');
      if (closeBtn) {
        closeDrawer(getDetails(closeBtn));
        return;
      }

      const overlay = event.target.closest('[data-hb-drawer-overlay]');
      if (overlay && event.target === overlay) {
        closeDrawer(getDetails(overlay));
      }
    });

    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.classList.contains('menu-drawer-container')) return;
      if (!details.closest('.header--hb')) return;

      if (details.open) {
        lockScroll();
      } else {
        unlockScroll();
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
